<template>
  <div class="page-joinUs">
    <!--悬浮头部-->
    <Header></Header>
    <!--banner-->
    <div class="banner">
      <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/family_banner.jpg">
      <ul class="content">
        <li @click.stop="showChange('1')" :class="{'active':tab=='1'}">
          <div class="title">
            <p>KRK工作和生活</p>
          </div>
        </li>
        <li @click.stop="showChange('2')" :class="{'active':tab=='2'}">
          <div class="title">
            <p>立刻申请 Careers</p>
          </div>
        </li>
        <!-- <li  @click.stop="showChange('3')" :class="{'active':tab=='3'}">
          <div class="title"><p>给家长的一封信</p></div>
        </li>-->
      </ul>
    </div>
    <!--工作和生活-->
    <Work v-show="tab=='1'"></Work>
    <!--立刻申请-->
    <Careers v-show="tab=='2'"></Careers>
    <!-- 给家长的一封信 -->
    <Letter v-show="tab=='3'"></Letter>
    <!--底部-->
    <v-footer></v-footer>
  </div>
</template>


<script>
import Header from "@/components/header/Header"; //悬浮头部
import Work from "@/pages/join/work"; //工作和生活
import Careers from "@/pages/careers"; //立刻申请
import Letter from "@/pages/join/letter"; //给家长的一封信
import Footer from "@/components/footer/footer"; //底部模块

export default {
  data() {
    return {
      //    tab: this.$route.query.id,
      tab: ""
    };
  },
  components: {
    Header,
    Work,
    Careers,
    Letter,
    "v-footer": Footer
  },
  mounted() {
    //this.$nextTick(() => {
    this.getTab();
    //})
  },
  beforeRouteUpdate() {},
  watch: {
    $route(to, from) {
      if (to.path.indexOf("/join") > -1) {
        this.getTab();
      }
    }
  },
  methods: {
    getTab() {
      let route = this.$route.path;
      if (route.indexOf("/work") > -1) {
        this.tab = "1";
      } else if (route.indexOf("/careers") > -1) {
        this.tab = "2";
      } else if (route.indexOf("/letter") > -1) {
        this.tab = "3";
      }
    },
    showChange(val) {
      this.tab = val;
      switch (val) {
        case "1":
          this.$router.push({ name: "work" });
          break;
        case "2":
          this.$router.push({ name: "careers" });
          break;
        case "3":
          this.$router.push({ name: "letter" });
          break;
        default:
          break;
      }
    }
  }
};
</script>


<style rel="stylesheet/scss" lang="scss">
@import "@/assets/css/variables.scss";
.page-joinUs {
  .banner {
    width: 100%;
    position: relative;
    img {
      display: block;
      width: 100%;
    }
    .content {
      position: absolute;
      left: 50%;
      margin-left: -600px;
      bottom: 0;
      height: 68px;
      li {
        position: relative;
        /* width:228px;
        height: 68px;*/
        float: left;
        background: rgba(0, 0, 0, 0.6);
        text-align: center;
        cursor: pointer;
        div.title {
          p {
            width: auto;
            height: 68px;
            padding: 0px 54px;
            font-size: 24px;
            font-family: PingFangSC-Regular;
            color: rgba(255, 255, 255, 1);
            line-height: 68px;
          }
        }
      }
      .active {
        background: rgba(0, 40, 93, 1);
      }
      li:hover {
        background: rgba(0, 40, 93, 1);
      }
    }
  }
}
@media (max-width: 767px) {
  .page-joinUs {
    .banner {
      padding-top: 45px;
      .content {
        width: 100%!important;
        position: absolute;
        left: 0!important;
        margin-left: 0!important;
        bottom: 0;
        height: 35px!important;
        display: flex;
        white-space: nowrap;
        overflow-x: scroll;
        overflow-y: hidden;
        -webkit-backface-visibility: hidden;
        -webkit-perspective: 1000;
        -webkit-overflow-scrolling: touch;
        text-align: justify;
        li {
          width: 100%;
          div.title {
            #world {
              width: auto;
              padding: 0 24px;
              height: 35px!important;
            }
            p {
              width: auto;
              padding: 0 24px!important;
              height: 35px!important;
              font-size: 14px!important;
              line-height: 35px!important;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/join/joinUs.vue